import * as React from "react"
import styled from "@digits-css"
import { Lottie } from "@digits-shared/components/UI/Lottie/Lottie"
import { type ButtonSize } from "@digits-shared/DesignSystem/Button"
import "./CenteredLoader.digits.css"

const Center = styled.div({ cls: "CenteredLoader__Center_4b86ae1" })

// extra specificity is needed to prevent button level overrides
const LoaderAnim = styled(Lottie)({ cls: "CenteredLoader__LoaderAnim_546f19b" })

/**
 * Provides a Lottie-based loading animation
 */
export const Loader: React.FC<{ className?: string; size: ButtonSize; paused?: boolean }> = ({
  className,
  size,
  paused,
}) => (
  <LoaderAnim
    className={className}
    aria-label="loading"
    animationData={require("digits-shared/static/lottie/bubble-loader.json")}
    autoplay={!paused}
    data-size={size}
  />
)

/**
 * Centers a loading animation within the parent container
 */
export const CenteredLoader: React.FC<{ className?: string; size: ButtonSize }> = ({
  className,
  size,
}) => (
  <Center className={className}>
    <Loader size={size} />
  </Center>
)
